import { useEffect } from 'react';

const useRewardListScroll = ({ containerRef, listRef, totalRef, onReachBottom }) => {
  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return undefined;
    }

    const handleScroll = () => {
      if (listRef.current.length === totalRef.current) {
        return;
      }

      if (container.scrollTop + container.clientHeight > container.scrollHeight - 40) {
        onReachBottom();
      }
    };

    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);
};

export default useRewardListScroll;
